import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faUserTimes } from "@fortawesome/free-solid-svg-icons"

export const UserTimes = (props) => {
  return <FontAwesomeIcon faIcon={faUserTimes} {...props} />
}
